<template>
  <!-- eslint-disable -->
  <b-sidebar
    class="biendong-sidebar"
    id="nghi-viec-sidebar"
    :visible="isShowSidebar"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-show-sidebar', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Thông tin biến động đến</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>
      <!-- BODY -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <b-row>
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Đơn vị chuyển đi"
                rules="required"
              >
                <b-form-group
                  label="Đơn vị chuyển đi"
                  label-for="donViDi"
                  :state="getValidationState(validationContext)"
                >
                  <treeselect
                    v-on:select="format"
                    :options="donVis"
                    value-format="object"
                    v-model="valueDonVi"
                    :searchable="true"
                    :show-count="true"
                    :default-expand-level="1"
                    :normalizer="normalizer"
                    placeholder=""
                    :disabled="isWait || (formData.id && formData.id != '')"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Quyết định chuyển đi"
              >
                <b-form-group
                  label="Quyết định chuyển đi"
                  label-for="quyetDinhChuyen"
                >
                  <b-form-input
                    id="quyetDinhChuyen"
                    v-model="formData.quyetDinhChuyen"
                    :state="getValidationState(validationContext)"
                    :disabled="isWait || (formData.id && formData.id != '')"
                    placeholder=""
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <b-form-group label="Lý do chuyển đi" label-for="lyDoChuyen">
                <v-select
                  placeholder=""
                  v-model="formData.lyDoChuyen"
                  label="name"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="DM_LOAIQUYETDINH_CONGTAC"
                  :disabled="isWait || (formData.id && formData.id != '')"
                  :reduce="(val) => val"
                  input-id="lyDoChuyen"
                />
              </b-form-group>
            </b-col>
            <!-- <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Phòng ban đến"
                rules=""
              >
                <b-form-group
                  label="Phòng ban đến"
                  label-for="phongBanDen"
                  :state="getValidationState(validationContext)"
                >
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    v-model="formData.phongBanDen"
                    :reduce="(val) => val"
                    :options="phongBans"
                    label="name"
                    :clearable="false"
                    :disabled="isWait"
                    input-id="phongBanDen"
                  >
                    <template #option="{ name, level, parents }">
                      <span
                        v-if="level > 1"
                        :class="[level > 1 ? 'ml-' + (level - 2) : '']"
                      >
                        <feather-icon
                          icon="CornerDownRightIcon"
                          size="16"
                          class="align-middle"
                        />
                      </span>
                      <span>
                        {{ name }}
                      </span>
                    </template>
                  </v-select>
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col> -->
            <b-col md="6">
              <validation-provider
                #default="validationContext"
                name="Ngày chuyển đến"
                rules="required"
              >
                <b-form-group
                  label="Ngày chuyển đến"
                  label-for="ngayChuyenDen"
                  :state="getValidationState(validationContext)"
                >
                  <!-- <b-form-datepicker
                    locale="vi"
                    placeholder=""
                    class="mb-1"
                    selected-variant="info"
                    v-model="formData.ngayChuyenDen"
                    :date-format-options="{
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    }"
                  /> -->
                  <flat-pickr
                    v-model="formData.ngayChuyenDen"
                    class="form-control"
                    placeholder="__/__/____"
                    :config="{
                      wrap: true,
                      allowInput: true,
                      dateFormat: 'Y-m-d',
                      altInput: true,
                      altFormat: 'd/m/Y',
                    }"
                  />
                  <b-form-invalid-feedback
                    :state="getValidationState(validationContext)"
                  >
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="12">
              <b-form-group label="Tệp tin" label-for="tepTin">
                <div
                  v-if="formData.file.length > 0"
                  v-for="file in formData.file"
                >
                  <b-link
                    class="ml-25"
                    :href="`${urlFile}/files/view/${file.fileId}`"
                    target="_blank"
                    >{{ file.fileName }}</b-link
                  >
                </div>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <div class="d-flex mt-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  class="mr-2"
                  :disabled="isWait"
                  type="submit"
                >
                  Lưu
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="button"
                  variant="outline-secondary"
                  :disabled="isWait"
                  @click="hide"
                >
                  Hủy
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
/* eslint-disable */
import {
  BRow,
  BCol,
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormDatepicker,
  BFormCheckbox,
  BLink,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, alphaNum, email, url } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ref, computed, watch } from "@vue/composition-api";
import {
  CanBoCongChucBienDongAccept as Accept,
  CanBoCongChucBienDongRefuse as Refuse,
} from "@/services/api/HoSoCanBoCongChuc/CanBoCongChucBienDongService";
import useSetup from "../useSetup";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import flatPickr from "vue-flatpickr-component";
import flatpickr from "flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn.js";
flatpickr.localize(Vietnamese);

const defaultData = {
  id: null,
  name: null,
  code: null,
};
export default {
  /* eslint-disable */
  components: {
    BRow,
    BCol,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    BFormDatepicker,
    BFormCheckbox,
    BLink,
    Treeselect,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  props: {
    donVis: {
      type: Array,
      required: true,
    },
    donViDefaultSelected: {
      type: Object,
      default: {},
    },
    cbccvcDetail: {
      type: Object,
      required: true,
    },
    isShowSidebar: {
      type: Boolean,
      required: true,
    },
  },
  created() {
    this.fnGetLoaiQuyetDinhCongTac();
  },
  watch: {
    isShowSidebar(val) {
      if (val) {
        this.formData = this.cbccvcDetail.bienDong;
        console.log("this.formData", this.formData);
        this.valueDonVi = {
          id: this.formData.donViDi.id,
          label: this.formData.donViDi.ten,
          maCoQuan: this.formData.donViDi.maCoQuan,
          isSyncQG: this.formData.donViDi.isSyncQG,
        };
      }
    },
  },
  data() {
    return {
      valueDonVi: null,
      urlFile: process.env.VUE_APP_BASE_API,
      isWait: false,
      formData: {},
      required,
      alphaNum,
      email,
      url,
      DM_LOAIQUYETDINH_CONGTAC: [],
    };
  },
  methods: {
    fnGetLoaiQuyetDinhCongTac() {
      this.$store
        .dispatch("common/fetchLoaiQuyetDinhCongTac")
        .then((response) => {
          this.DM_LOAIQUYETDINH_CONGTAC = response;
        });
    },
    format(node, instanceId) {
      // console.log("node", node);
      this.formData.donViDi = {
        id: node.id,
        ten: node.label,
        maCoQuan: node.maCoQuan,
        isSyncQG: node.isSyncQG,
      };
    },
    normalizer(node) {
      if (node.children == null || node.children == "null") {
        delete node.children;
      }
    },
    async onSubmit() {
      if (this.isWait) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Notification",
            icon: "CoffeeIcon",
            variant: "info",
            text: "In Progress",
          },
        });
      } else {
        this.isWait = true;
        var res = await Accept({
          id: this.cbccvcDetail.id,
          bienDong: this.formData,
        });
        this.isWait = false;
        if (res.isError) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thất bại",
              icon: "AlertTriangleIcon",
              variant: "error",
              text: res.message,
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Thành công",
              icon: "CheckIcon",
              variant: "success",
              text: res.message,
            },
          });
          this.$emit("update:is-show-sidebar", false);
          //   this.formData.id = res.data.id;
          this.$emit("update-trang-thai-bien-dong-den", this.formData);
        }
      }
    },
  },
  setup() {
    const { refFormObserver, getValidationState, resetForm } = formValidation(
      () => {
        //Reset form
      }
    );

    const { loadPhongBan } = useSetup();
    const phongBans = ref([]);
    const onChangeDonVi = (donViId) => {
      loadPhongBan(
        {
          parentId: donViId,
        },
        function (data) {
          phongBans.value = data;
        }
      );
    };

    return {
      // UI
      refFormObserver,
      getValidationState,
      resetForm,

      phongBans,
      onChangeDonVi,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
